import React from 'react'
import { graphql } from 'relay-runtime'
import { PreloadedQuery, useFragment, usePreloadedQuery } from 'react-relay'
import { useIsGuest } from 'hooks/user'
import { BlogSubcategory_User$key } from '__generated__/BlogSubcategory_User.graphql'
import { BlogSubcategory_Query } from '__generated__/BlogSubcategory_Query.graphql'
import BlogSubcategoryLanding from '../BlogSubcategoryLanding/BlogSubcategoryLanding'
import BlogSubcategorySignedIn from '../BlogSubcategorySignedIn'

export const BlogSubcategoryQuery = graphql`
  query BlogSubcategory_Query($subcategory: String!) {
    currentUser {
      ...BlogSubcategory_User
      ...auth_checkAuthForPage
    }

    blogSubcategory(slug: $subcategory) {
      __typename
    }

    ...BlogSubcategoryLanding_Query @arguments(subcategory: $subcategory)
    ...BlogSubcategorySignedIn_Query @arguments(subcategory: $subcategory)
  }
`

export const isAllowed = () => {
  return true
}

function BlogSubcategory({ preloadedQuery }: { preloadedQuery: PreloadedQuery<BlogSubcategory_Query> }) {
  const data = usePreloadedQuery(BlogSubcategoryQuery, preloadedQuery)

  const user = useFragment<BlogSubcategory_User$key>(graphql`
    fragment BlogSubcategory_User on User {
      ...user_useIsGuest
    }
  `, data?.currentUser)

  const guest = useIsGuest(user)

  if (guest) {
    return (
      <BlogSubcategoryLanding queryFragmentRef={data} />
    )
  }

  return (
    <BlogSubcategorySignedIn queryFragmentRef={data} />
  )
}

export default React.memo(BlogSubcategory)
